import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const navItems = [
        { name: "Home", path: "/" },
        { name: "About", path: "/about" },
        { name: "Products", path: "/products" },
        { name: "Contact", path: "/contact" },
    ];

    const navLinkClass =
        "block px-4 py-2 text-white hover:text-[#FFD93D] font-medium transition";

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    return (
        <nav className="bg-[#003865] shadow sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo and Tagline */}
                    <div className="flex items-center space-x-3">
                        {/* <img src="/assets/logo.png" alt="AXS Logo" className="h-10 w-auto" /> */}
                        <div className="text-white font-bold text-4xl">AXS</div>
                        <div className="text-[#D80073] text-sm hidden sm:inline border-l border-white pl-3">
                            Excellence Without Limits
                        </div>
                    </div>

                    {/* Hamburger Icon */}
                    <div className="lg:hidden">
                        <button onClick={toggleMenu} className="text-white">
                            {isOpen ? <X size={28} /> : <Menu size={28} />}
                        </button>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden lg:flex space-x-6">
                        {navItems.map((item) => (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                onClick={closeMenu}
                                className={({ isActive }) =>
                                    isActive
                                        ? `${navLinkClass} text-[#FFD93D] border-b-2 border-[#FFD93D]`
                                        : navLinkClass
                                }
                            >
                                {item.name}
                            </NavLink>
                        ))}
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="lg:hidden bg-[#003865] px-4 py-2 space-y-1">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            onClick={closeMenu}
                            className={({ isActive }) =>
                                isActive
                                    ? `${navLinkClass} text-[#FFD93D]`
                                    : navLinkClass
                            }
                        >
                            {item.name}
                        </NavLink>
                    ))}
                </div>
            )}
        </nav>
        
    );
}

export default Navbar;
